import { FaRProject, FaPercentage, FaYoutubeSquare, FaMailBulk, FaInfo, FaLaptopCode } from 'react-icons/fa';
import lins2shopImg from '@assets/projects/links2shop.png';
import obokImage from '@assets/projects/obok.png';
import connexWebImage from '@assets/projects/6connex.webp';
import bitcoinPaypal from '@assets/projects/Plataforma-Intercambio-PayPal-Bitcoin.jpg.webp';
import velosticsImg from '@assets/projects/velostics.png';
import ksquaresImg from '@assets/projects/ksquare.png';
import baxterImg from '@assets/projects/baxter.png';
import doqmindImg from '@assets/projects/doqmind.png';
import satokoImg from '@assets/projects/satoko.png';
import tecoImg from '@assets/projects/grupoteco.png';
import akibaImg from '@assets/projects/akiba-street.png';

export const NAV_PAGES = [
  {
    name: 'Projects',
    link: '#projects',
    type: 'ref',
    icon: <FaRProject />
  },
  {
    name: 'Experience',
    link: '#experience',
    type: 'ref',
    icon: <FaPercentage />
  },
  {
    name: 'What I Do',
    link: '/what-i-do',
    type: 'link',
    icon: <FaLaptopCode />
  },
  {
    name: 'Youtube',
    link: 'https://www.youtube.com/@codexmaker4568',
    type: 'link',
    icon: <FaYoutubeSquare />
  },
  {
    name: 'Contact',
    link: '#contact',
    type: 'ref',
    icon: <FaMailBulk />
  },
  {
    name: 'Certs',
    link: '#certs',
    type: 'ref',
    icon: <FaInfo />
  }
];

export const PAGES = {
  home: 'home',
  about: 'about',
  projects: 'projects',
  skills: 'skills',
  experience: 'experience',
  recommendations: 'recommendations',
  contact: 'contact',
  youtube: 'youtube'
};

export type Project = {
  id: number;
  title: string;
  des: string;
  img: string;
  iconLists: string[];
  link: string;
  career_impacts: string[];
  roles?: string[];
};

export const MyProfileData = [
  {
    id: 1,
    title:
      'I prioritize client collaboration, delivering quality business solutions, using an Agile work methodology, MERN, or MEAN tools.',
    description: 'asdasdsdas',
    className: 'lg:col-span-3 md:col-span-6 md:row-span-4 lg:min-h-[60vh]',
    imgClassName: 'absolute my-[10%] mx-[25%]',
    titleClassName: 'justify-end',
    img: '/userDesc.png',
    spareImg: ''
  },
  {
    id: 2,
    title: 'I enjoy the process to adapt and domain new challenges',
    description: '',
    className: 'lg:col-span-2 md:col-span-3 md:row-span-2',
    imgClassName: '',
    titleClassName: 'justify-start',
    img: '',
    spareImg: ''
  },
  {
    id: 3,
    title: 'My tech stack',
    description: 'I constantly try to improve',
    className: 'lg:col-span-2 md:col-span-3 md:row-span-2',
    imgClassName: '',
    titleClassName: 'justify-center',
    img: '',
    spareImg: ''
  },
  {
    id: 4,
    title: 'Tech enthusiast with a passion for development.',
    description: '',
    className: 'lg:col-span-2 md:col-span-3 md:row-span-1',
    imgClassName: '',
    titleClassName: 'justify-start',
    img: '/grid.svg',
    spareImg: '/b4.svg'
  },

  {
    id: 5,
    title: 'Currently building a TCG game',
    description: 'The Inside Scoop',
    className: 'md:col-span-3 md:row-span-2',
    imgClassName: 'absolute right-0 bottom-0 md:w-96 w-60',
    titleClassName: 'justify-center md:justify-start lg:justify-center',
    isVideo: true,
    videoLink: '/video/tcg-demo.mp4',
    spareImg: '/grid.svg'
  },
  {
    id: 6,
    title: 'Do you want to start a project together?',
    description: '',
    className: 'lg:col-span-2 md:col-span-3 md:row-span-1',
    imgClassName: '',
    titleClassName: 'justify-center md:max-w-full max-w-60 text-center',
    img: '',
    spareImg: ''
  }
];

export const MY_PROJECTS: Project[] = [
  {
    id: 1,
    title: 'Satoko - Mexican Tax Declaration Assistant',
    des: 'Built an AI-powered tax assistant platform for Mexican taxpayers to simplify SAT (tax authority) declarations using Next.js, AWS, and advanced tax calculation algorithms.',
    img: satokoImg,
    iconLists: [
      'nextdotjs',
      'react',
      'typescript',
      'amazon',
      'prisma',
      'tailwindcss',
      'framer',
      'chartdotjs',
      'nodedotjs',
      'zod'
    ],
    link: 'https://satokoai.com',
    career_impacts: [
      'Developed complex tax calculation engine for RESICO and Salary regimes with Mexican SAT compliance',
      'Implemented XML parser for CFDI 4.0 invoices with automatic tax extraction and categorization',
      'Integrated AWS S3 for secure document storage with presigned URLs for sensitive tax documents',
      'Built real-time tax anomaly detection system identifying employer ISR withholding discrepancies',
      'Created interactive data visualizations using Chart.js and Plotly for tax forecasting and analysis',
      'Designed responsive UI with Framer Motion animations and Radix UI components for enhanced UX',
      'Implemented NextAuth authentication with Prisma ORM for secure user data management',
      'Architected file upload system with XML parsing capabilities for automated invoice processing'
    ],
    roles: ['Full Stack Developer', 'Tax Software Engineer']
  },
  {
    id: 2,
    title: 'TECO HQ - Cloud Document Management System',
    des: 'Enterprise document management platform with AWS S3 integration, featuring secure file storage, organization management, email integration, and real-time collaboration using Next.js and TypeScript.',
    img: tecoImg,
    iconLists: ['react', 'nextdotjs', 'typescript', 'tailwindcss', 'amazon', 'nodedotjs', 'framer'],
    link: 'https://grupoteco.mx/es',
    career_impacts: [
      'Built secure cloud storage system with AWS S3 integration',
      'Implemented file upload/download with signed URLs for enhanced security',
      'Created organization and user management with role-based access control',
      'Developed email conversation system with real-time notifications',
      'Integrated push notifications using VAPID for user engagement',
      'Built document viewer with 3D visualization using Three.js and React Three Fiber',
      'Implemented tag-based file organization and search functionality',
      'Created vault system for secure document storage and sharing',
      'Developed QR code generation for file sharing',
      'Built ERP dashboard with metrics and analytics'
    ],
    roles: ['Full Stack Developer', 'Frontend Engineer']
  },
  {
    id: 3,
    title: 'GetHypercube Cloud Tool Integration',
    des: 'Integrated multiple cloud tools (AWS, Azure, GCP, Oracle) for calculating balances and forecasts using MERN stack and containerization.',
    img: obokImage,
    iconLists: [
      'mongodb',
      'amazon',
      'Azure',
      'googlecloud',
      'oracle',
      'react',
      'nodedotjs',
      'typescript',
      'docker',
      'redux'
    ],
    link: 'https://www.gethypercube.com/',
    career_impacts: [
      'Increased application efficiency with multiple cloud tools',
      'Enhanced financial forecasting accuracy',
      'Integrated Azure stack  for cloud services such as cost calculation, savings and forecasting',
      'Integrated Oracle stack  for cloud services such as cost calculation, savings and forecasting',
      'Created file generators with charts for the customers reports',
      'Worked with data models and EFS for storage lambda dependencies at AWS'
    ],
    roles: ['Software Engineer', 'Devops']
  },
  {
    id: 4,
    title: 'GetObok Data Atomization Tool',
    des: 'Developed multiple tools for data atomization and vault model; migrated state management from MOBX to Redux toolkit.',
    img: obokImage,
    iconLists: [
      'amazon',
      'Azure',
      'googlecloud',
      'oracle',
      'react',
      'nodedotjs',
      'typescript',
      'docker',
      'mobx',
      'redux',
      'mongodb',
      'cockroachlabs',
      'go'
    ],
    link: 'https://www.getobok.com/',
    career_impacts: [
      'Improved data handling and processing efficiency',
      'Simplified state management migration',
      'Migrated Mobx to ReduxJs',
      'GitActions templates for CI/CD'
    ],
    roles: ['Software Engineer', 'Devops']
  },
  {
    id: 6,
    title: 'E-commerce Site Revamp for Helbling English',
    des: 'Led e-commerce site redevelopment with MEAN stack; improved architecture for multi-user flows, boosting adoption by 15%.',
    img: lins2shopImg,
    iconLists: [
      'digitalocean',
      'amazon',
      'php',
      'sass',
      'javascript',
      'laravel',
      'nodejs',
      'express',
      'mysql',
      'angularjs'
    ],
    link: 'https://links2books.com/',
    career_impacts: [
      `Reinterpretation and lead of the ecommerce site of the company, with MEAN stack improving the architecture of the
business model`,

      `The company saved around 400$ monthly in the new suggested VPS, created solutions for their past platforms, solving
bottlenecks and refactoring the code for a better performance.`,

      `Lead a team of 6 developers to integrate mailing and gateway payments in a record time .`,

      'Boosted operational efficiency by 30% with microservices'
    ],
    roles: ['Software Engineer', 'Devops', 'Team Lead', 'Fullstack', 'QA', 'UX/UI Designer', 'DBA']
  },
  {
    id: 7,
    title: '6 Connex Real-Time React Application',
    des: 'Developed socket connections for real-time updates in a React app; migrated legacy code to VueJS for enhanced user engagement.',
    img: connexWebImage,
    iconLists: ['socketdotio', 'vuedotjs', 'nodedotjs', 'vitest', 'bitbucket'],
    link: 'https://www.6connex.com/platform/virtual-venues/',
    career_impacts: [
      'Enhanced user engagement through real-time updates',
      'Improved app responsiveness with VueJS migration'
    ],
    roles: ['Software Engineer - Frontend']
  },
  {
    id: 8,
    title: 'Crypto Payments',
    des: 'Developed a solution for capturing and sending cryptocurrency payments, including integration of a web scraping system to replicate content dynamically within the platform.',
    img: bitcoinPaypal,
    iconLists: [
      'digitalocean',
      'nodedotjs',
      'webscraping',
      'angularjs',
      'JavaScript',
      'paypal',
      'crypto',
      'express',
      'mongodb'
    ],
    link: '', // replace with actual link if available
    career_impacts: [
      'Streamlined payment processing, increasing efficiency by 50%',
      'Enhanced platform capabilities with automated content replication',
      'Expanded expertise in cryptocurrency transaction handling'
    ],
    roles: ['Software Engineer - Fullstack']
  },
  {
    id: 9,
    title: 'Velostics',
    des: 'Developed solutions for logistics scheduling, integrating Redis for data storage, and migrating legacy JSP pages to VueJS to enhance user experience.',
    img: velosticsImg,
    iconLists: ['socketdotio', 'vuedotjs', 'nodedotjs', 'vitest', 'bitbucket', 'redis', 'ruby'],
    link: 'https://www.velostics.com/', // replace with actual link if available
    career_impacts: [
      'Increased scheduling efficiency with Redis integration',
      'Enhanced application performance and usability',
      'Applied TDD for reliable component development'
    ],
    roles: ['Software Engineer - Frontend']
  },
  {
    id: 10,
    title: 'The Ksquare Group',
    des: 'Worked as a NodeJS Engineer to migrate monolithic software to microservices, leveraging AWS CloudFormation for efficient cloud environment setup.',
    img: ksquaresImg,
    iconLists: [
      'awslambda',
      'awsfargate',
      'awselasticloadbalancing',
      'axios',
      'awsamplify',
      'nodedotjs',
      'amazon',
      'react',
      'angularjs',
      'typescript',
      'yaml'
    ],
    link: 'https://www.theksquaregroup.com/', // replace with actual link if available
    career_impacts: [
      'Improved scalability and modularity through microservices',
      'Set up robust cloud environments with AWS CloudFormation',
      'Enhanced development processes with modern stack migration'
    ],
    roles: ['Senior Software Engineer - Backend']
  },
  {
    id: 11,
    title: 'Baxter Healthcare Billing Solution',
    des: 'Implemented updates to ensure regulatory compliance for healthcare billing in Colombia, meeting legal standards for certification.',
    img: baxterImg,
    iconLists: ['socketdotio', 'vuedotjs', 'nodedotjs', 'vitest', 'bitbucket', 'redis', 'ruby', 'mysql', 'java'],
    link: 'https://www.baxter.com.co/', // replace with actual link if available
    career_impacts: [
      'Achieved regulatory compliance for healthcare billing',
      'Ensured certification for legal processing in healthcare',
      'Enhanced industry-specific skills in healthcare solutions'
    ],
    roles: ['Software Engineer - Frontend', 'Devops', 'Frontend Lead']
  },
  {
    id: 12,
    title: 'Doqmind Design Application',
    des: 'Served as a Frontend Developer to build responsive, dynamic layouts and optimize canvas handling to support designer flexibility.',
    img: doqmindImg,
    iconLists: ['vuejs', 'javascript', 'vitest', 'canvas', 'sockets', 'pixel'],
    link: 'https://doqmind.com/', // replace with actual link if available
    career_impacts: [
      'Improved usability with flexible, responsive design',
      'Enhanced front-end skills for dynamic content handling',
      'Contributed to a high-quality designer-oriented tool'
    ],
    roles: ['Software Engineer - Frontend']
  },
  {
    id: 13,
    title: 'Akiba Street -TCG Ecommerce APP',
    des: 'Designed and implenet using NextJS for SEO in the articles an ecommerce that sells cards, anime merch and bids.',
    img: akibaImg,
    iconLists: ['nextjs', 'javascript', 'vitest', 'canvas', 'sockets', 'pixel'],
    link: 'https://akibastreet xyz',
    career_impacts: [
      'Improved usability with flexible, responsive design',
      'Enhanced front-end skills for dynamic content handling'
    ],
    roles: ['Software Engineer - Fullstack']
  }
];

export type WorkExperience = {
  id: number;
  title: string;
  description: string;
  icon: string;
  highlights: string[];
  techStack: string[];
};

export const MY_WORK_EXPERIENCE: WorkExperience[] = [
  {
    id: 1,
    title: 'Backend Senior Developer',
    description:
      'Worked as NodeJs, Ruby, Python developer creating REST solutions and cloud functions for apps scalability.',
    icon: '/code_thinking.svg',
    highlights: [
      'Designed RESTful APIs serving 50K+ daily requests',
      'Built serverless architectures with AWS Lambda & API Gateway',
      'Optimized database queries reducing response time by 40%'
    ],
    techStack: ['Node.js', 'Python', 'Ruby', 'AWS Lambda', 'PostgreSQL', 'Redis']
  },
  {
    id: 2,
    title: 'Frontend Senior Developer',
    description:
      'Worked as Angular, React, Vue developer creating SPA solutions with atomic design patterns, and responsive designs with scalable code and best practices.',
    icon: '/programming.svg',
    highlights: [
      'Implemented micro-frontend architecture for enterprise apps',
      'Reduced bundle size by 60% with code-splitting strategies',
      'Built reusable component libraries used across 5+ projects'
    ],
    techStack: ['React', 'Angular', 'Vue.js', 'TypeScript', 'Tailwind CSS', 'Storybook']
  },
  {
    id: 3,
    title: 'Software Engineer Full Stack',
    description:
      'Worked in multiple projects using MEAN stack, MERN stack, MEVN stack with containerization, starting with the concepts to the final steps at production on multiple cloud providers.',
    icon: '/developer_activity.svg',
    highlights: [
      'Delivered 10+ full-stack applications from concept to production',
      'Integrated third-party APIs including payment gateways & CRMs',
      'Implemented real-time features with WebSockets & Server-Sent Events'
    ],
    techStack: ['MongoDB', 'Express', 'React', 'Node.js', 'Docker', 'AWS']
  },
  {
    id: 4,
    title: 'Lead Software Engineer',
    description:
      'Led a team of 6 developers to integrate mailing and gateway payments in record time, and migrate monolithic software to microservices, leveraging AWS CloudFormation for efficient cloud environment setup.',
    icon: '/code_thinking.svg',
    highlights: [
      'Managed cross-functional team of 6 engineers across 3 time zones',
      'Reduced deployment time from 2 hours to 15 minutes with CI/CD',
      'Architected microservices migration saving $400/month in infra costs'
    ],
    techStack: ['AWS CloudFormation', 'Docker', 'Kubernetes', 'GitHub Actions', 'Terraform']
  },
  {
    id: 5,
    title: 'DevOps Engineer',
    description:
      'Set up CI/CD pipelines, containerization, and orchestration for scalable cloud solutions, enhancing development and deployment processes.',
    icon: '/server_cluster.svg',
    highlights: [
      'Designed multi-region deployment pipelines with 99.9% uptime',
      'Containerized 15+ legacy applications with Docker & K8s',
      'Implemented infrastructure-as-code reducing provisioning time by 80%'
    ],
    techStack: ['Docker', 'Kubernetes', 'Terraform', 'AWS', 'GitHub Actions', 'Nginx']
  }
];

export const STACK_OF_SLUGS = [
  'oracle',
  'awslambda',
  'awsfargate',
  'awselasticloadbalancing',
  'axios',
  'awsamplify',
  'canvas',
  'clerk',
  'cockroachlabs',
  'go',
  'googleadsense',
  'googleads',
  'knowledgebase',
  'materialdesign',
  'mamp',
  'nodedotjs',
  'paypal',
  'pm2',
  'puppeteer',
  'python',
  'redux',
  'trello',
  'ubuntu',
  'vuedotjs',
  'yaml',
  'reactrouter',
  'rabbitmq',
  'mongodb'
];

export const CERTIFICATIONS = [
  {
    id: 1,
    title: 'AWS Cloud Practitioner',
    description: 'Validated knowledge of AWS Cloud concepts, services, security, architecture, and pricing.',
    img: '/certs/aws.png',
    issuer: 'Amazon Web Services',
    year: '2023',
    skills: ['Cloud Architecture', 'AWS Services', 'Security', 'Cost Optimization']
  },
  {
    id: 2,
    title: 'React Developer',
    description: 'Certified proficiency in React ecosystem including hooks, state management, and component patterns.',
    img: '/certs/cafeto.png',
    issuer: 'Cafeto Software',
    year: '2022',
    skills: ['React', 'Redux', 'Component Design', 'Performance Optimization']
  },
  {
    id: 3,
    title: 'Java SE 8 Developer',
    description: 'Demonstrated expertise in Java SE 8 features including lambda expressions, streams, and concurrency.',
    img: '/certs/java.png',
    issuer: 'Oracle',
    year: '2021',
    skills: ['Java 8', 'OOP', 'Streams API', 'Multithreading']
  },
  {
    id: 4,
    title: 'Scrum Fundamentals',
    description: 'Certified understanding of Scrum framework, agile principles, and team collaboration practices.',
    img: '/certs/scrum.jpeg',
    issuer: 'SCRUMstudy',
    year: '2021',
    skills: ['Agile', 'Sprint Planning', 'Scrum Events', 'Team Collaboration']
  }
];

export const SOCIAL_MEDIA = [
  {
    id: 1,
    img: '/git.svg',
    link: 'https://github.com/CodeXMakerCompany'
  },
  {
    id: 2,
    img: '/youtube.svg',
    link: 'https://www.youtube.com/@codexmaker4568'
  },
  {
    id: 3,
    img: '/link.svg',
    link: 'https://www.linkedin.com/in/codexmaker/'
  }
];
